import React from 'react';
import { Instagram, MessageCircle, ArrowUpRight, Sparkles } from 'lucide-react';
import { profile } from '../mock';

const topics = [
  { label: 'Talleres de crianza y lactancia', icon: Sparkles },
  { label: 'Charlas para familias', icon: Sparkles },
  { label: 'Grupos terapéuticos', icon: Sparkles },
];

const Events = () => {
  const waLink = `${profile.whatsapp}?text=${encodeURIComponent(
    'Hola Karina! Vi tu web. Quiero saber sobre tus próximos talleres y encuentros.'
  )}`;

  return (
    <section
      id="eventos"
      className="py-20 lg:py-28 bg-[#F4EDE2] relative overflow-hidden"
      data-testid="talleres-section"
    >
      <div
        aria-hidden
        className="absolute -top-24 left-1/4 w-[460px] h-[460px] rounded-full opacity-40 blur-3xl"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, #EBC8C0 0%, #F4EDE2 60%, transparent 80%)',
        }}
      />
      <div
        aria-hidden
        className="absolute -bottom-16 right-0 w-[360px] h-[360px] rounded-full opacity-35 blur-3xl"
        style={{
          background:
            'radial-gradient(circle at 50% 50%, #C5D2BB 0%, #F4EDE2 60%, transparent 80%)',
        }}
      />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <div className="grid lg:grid-cols-[1.1fr,1fr] gap-12 lg:gap-20 items-center">
          {/* Left · invitation */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-mark" />
              <span className="eyebrow">Próximas actividades</span>
            </div>
            <h2 className="font-serif text-[38px] lg:text-[54px] leading-[1.04] text-[#2E2A23] tracking-[-0.02em] max-w-[640px]">
              Talleres
              <span className="italic text-[#B8806E]"> y encuentros.</span>
            </h2>
            <p className="mt-7 text-[16px] leading-[1.8] text-[#2E2A23]/80 font-light max-w-[560px]">
              Te invito a seguirme ahí, donde voy a compartir cada actividad
              apenas se abre. ¡Nos vemos!
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a
                href={profile.instagram}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
                data-testid="talleres-cta-instagram"
              >
                <Instagram size={16} strokeWidth={1.6} />
                Ver en Instagram
                <ArrowUpRight size={15} strokeWidth={1.7} />
              </a>
              <a
                href={waLink}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost"
                data-testid="talleres-cta-whatsapp"
              >
                <MessageCircle size={16} strokeWidth={1.6} />
                Consultar por WhatsApp
              </a>
            </div>

            <p className="mt-7 text-[12.5px] tracking-[0.16em] uppercase text-[#8A7E6E]">
              @karinanegrinpsico
            </p>
          </div>

          {/* Right · topics card */}
          <div className="relative">
            <div className="relative bg-[#FAF4E8] border border-[#DBCEB4] rounded-[28px] p-8 lg:p-10 shadow-[0_30px_70px_-35px_rgba(46,42,35,0.4)]">
              <div className="text-[11px] tracking-[0.28em] uppercase text-[#8A7E6E] mb-5">
                Tipos de propuestas que abro
              </div>
              <ul className="space-y-3.5">
                {topics.map((t, i) => {
                  const I = t.icon;
                  return (
                    <li
                      key={i}
                      className="flex items-center gap-4 px-5 py-3.5 rounded-2xl bg-[#F4EDE2] border border-[#E8DDC8]"
                    >
                      <span className="w-9 h-9 rounded-full bg-[#E8DDC8] grid place-items-center text-[#B8806E] flex-none">
                        <I size={16} strokeWidth={1.6} />
                      </span>
                      <span className="text-[15px] text-[#2E2A23]/90">
                        {t.label}
                      </span>
                    </li>
                  );
                })}
              </ul>

              <div className="mt-8 pt-6 border-t border-[#DBCEB4]">
                <p className="font-script text-[#B8806E] text-[24px] leading-tight">
                  cada encuentro,
                </p>
                <p className="font-serif italic text-[#2E2A23] text-[18px] mt-1">
                  con su propio espacio
                </p>
              </div>
            </div>

            {/* decorative dot */}
            <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full bg-[#FAF4E8] border border-[#DBCEB4] grid place-items-center shadow-md">
              <Instagram size={22} strokeWidth={1.4} className="text-[#B8806E]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
